import { createContext, useContext } from "react";
import { MAX_SEMESTER } from "utils/constants";

// Datagrid rows shadow the react-admin record context, so the plan is read from here instead.
export const CurriculumContext = createContext(null);

export const useCurriculum = () => useContext(CurriculumContext);

// A plan runs two semesters a year; without its length, fall back to the global cap.
export const useMaxSemester = () => {
  const curriculum = useCurriculum();
  return curriculum?.yearsOfStudy ? curriculum.yearsOfStudy * 2 : MAX_SEMESTER;
};
